module.exports = __webpack_public_path__ + "static/media/filter.6c78ca57.png";